import { useEffect, useState } from "react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL, scrollToId } from "../lib/site";

export const Monogram = ({ dark = false }) => (
    <span className="flex items-center gap-3" data-testid="brand-logo">
        <span
            className={`font-serif text-3xl leading-none tracking-tight ${
                dark ? "text-ink" : "text-white"
            }`}
        >
            B<span className="text-brass italic">&</span>B
        </span>
        <span className={`hidden sm:block h-6 w-px ${dark ? "bg-ink/30" : "bg-white/30"}`} />
        <span
            className={`hidden sm:block font-mono text-xs tracking-[0.35em] uppercase ${
                dark ? "text-ink/70" : "text-white/70"
            }`}
        >
            Bath & Beyond
        </span>
    </span>
);

const Nav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 border-b hairline-dark ${
                scrolled
                    ? "bg-noir/55 backdrop-blur-xl shadow-[0_10px_40px_rgba(0,0,0,0.3)]"
                    : "bg-ever/90 backdrop-blur-xl"
            }`}
        >
            <div className="mx-auto max-w-[1440px] px-5 sm:px-10 h-16 sm:h-20 flex items-center justify-between">
                <button
                    data-testid="nav-home-btn"
                    onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo(0, 0)}
                    className="cursor-pointer"
                    aria-label="Bath and Beyond home"
                >
                    <Monogram />
                </button>

                <div className="flex items-center gap-3 sm:gap-6">
                    <a
                        data-testid="nav-phone-link"
                        href={PHONE_TEL}
                        className="hidden md:block font-mono text-xs tracking-[0.15em] text-white/70 hover:text-brass transition-colors duration-300"
                    >
                        {PHONE_DISPLAY}
                    </a>
                    <a
                        data-testid="nav-whatsapp-btn"
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group flex items-center gap-2 rounded-full border hairline-dark bg-white/5 px-4 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm font-medium text-white backdrop-blur transition-all duration-300 hover:bg-brass hover:text-noir hover:border-brass"
                    >
                        <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
                            <path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.96L2 22l5.18-1.5A9.9 9.9 0 1 0 12.04 2Zm5.78 14.06c-.24.68-1.4 1.3-1.94 1.35-.5.05-1.13.24-3.8-1.02-3.2-1.5-5.2-4.9-5.36-5.12-.15-.22-1.24-1.7-1.2-3.2.04-1.5.85-2.22 1.14-2.53.28-.3.62-.36.83-.35.24 0 .48 0 .69.02.22.01.52-.09.8.63.29.74.96 2.56 1.04 2.75.09.19.14.4.02.63-.12.24-.24.39-.42.6-.18.2-.38.36-.55.58-.17.2-.36.43-.16.8.2.37.9 1.53 1.94 2.47 1.33 1.22 2.45 1.58 2.8 1.75.34.18.55.15.75-.09.2-.24.87-1.01 1.1-1.36.23-.35.46-.28.77-.17.31.12 1.98.94 2.32 1.1.34.18.56.26.65.4.08.15.08.83-.16 1.51Z" />
                        </svg>
                        <span className="hidden sm:inline">Chat on WhatsApp</span>
                        <span className="sm:hidden">WhatsApp</span>
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Nav;
